"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockedClass = exports.createAsyncMock = exports.asMock = void 0;
const tslib_1 = require("tslib");
const asMock = (func) => func;
exports.asMock = asMock;
const createAsyncMock = (returnValue) => {
    return jest.fn(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () { return yield Promise.resolve(returnValue); }));
};
exports.createAsyncMock = createAsyncMock;
const createMockedClass = (constructor) => {
    return new constructor();
};
exports.createMockedClass = createMockedClass;
//# sourceMappingURL=test.js.map